module.exports = __webpack_public_path__ + "app/modals/wz-qws-configure-output.view.html";